import { render, staticRenderFns } from "./EditarGrilla.vue?vue&type=template&id=01ff4eaa&"
import script from "./EditarGrilla.vue?vue&type=script&lang=ts&"
export * from "./EditarGrilla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports